import { render } from "./SubCategoryModal.vue?vue&type=template&id=7b581bdf&ts=true"
import script from "./SubCategoryModal.vue?vue&type=script&lang=ts"
export * from "./SubCategoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__